export default "__VITE_ASSET__Gfh_7$zJ__"